﻿import { createApp } from 'vue/dist/vue.esm-bundler';
const axios = require('axios');

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('quickSearch')) {
        const quickSearchApp = createApp({
            data() {
                return {
                    dataApi: '',
                    apiType: '',
                    dataSortKey: '',
                    dataSortDirection: '',
                    data: null,
                    facets: [],
                    monthFilterName: '',
                    ignorefacets: []
                }
            },
            computed: {
                orderItems() {
                    if (!this.dataSortKey && !this.dataSortDirection) return [];
                    return [
                        {
                            Key: this.dataSortKey,
                            Direction: this.dataSortDirection,
                        }
                    ]
                },
                queryModel() {
                    return {
                        Limit: 1,
                        Offset: 0,
                        OrderItems: this.orderItems,
                        FilterItems: [{ Key: 'agendaType.keyword', Values: [this.apiType], Operator: 'eq' }],
                        Text: ''
                    }
                },
                monthButtons() {
                    let dateFacet = this.facets.find(facet => facet.alias === this.monthFilterName);
                    if (!dateFacet) return [];

                    let dateOptions = dateFacet.options.map(option => {
                        option.valueAlias = option.valueAlias.replace(' ', 'T');
                        return option;
                    });

                    dateOptions = dateOptions.filter(option => new Date(option.valueAlias).getYear() !== new Date('9999-12-31T23:59:59').getYear());
                    this.monthFilterTitle = dateFacet.title
                    if (!dateOptions.length) return [];
                    else {
                        let firstDate = new Date(dateOptions[0].valueAlias);
                        let lastDate = new Date(dateOptions[dateOptions.length - 1].valueAlias);
                        lastDate.setMonth(lastDate.getMonth() + 1);
                        let monthButtons = [];
                        let date = new Date(firstDate);
                        do {
                            if (new Date(date.getFullYear(), date.getMonth() + 1, 0) > new Date()) {
                                monthButtons.push({
                                    year: date.getFullYear(),
                                    month: date.getMonth(),
                                    label: date.toLocaleDateString('nl-NL', { month: 'short' }).replace('.', ''),
                                    from: new Date(date.getFullYear(), date.getMonth(), 1).toISOString(),
                                    to: new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString(),
                                    disabled: !dateOptions.some(option =>
                                        new Date(option.valueAlias).getFullYear() === date.getFullYear() &&
                                        new Date(option.valueAlias).getMonth() === date.getMonth())
                                })
                            }
                            date.setMonth(date.getMonth() + 1);
                        }
                        while ((date.getFullYear() !== lastDate.getFullYear()) || (date.getMonth() !== lastDate.getMonth()))

                        return monthButtons;
                    }
                }
            },
            methods: {
                fetchData() {
                    axios
                        .post(this.dataApi, this.queryModel)
                        .then(response => {
                            if (response.status === 200) {
                                this.data = response.data;
                                this.facets = this.data.facets.map(facet => {
                                    if (facet.alias === 'genres.id.keyword') {
                                        facet.options.map(facetOption => {
                                            facetOption.text = facetOption.text.toLowerCase();
                                        });
                                    }
                                    return {
                                        ...facet
                                    }
                                });
                                this.facets = this.facets.filter(facet => this.ignorefacets.includes(facet.alias) == false);
                            }
                        })
                        .catch(error => console.log(error))
                },
                groupedFacetOptions(facet) {
                    let groupedOptions = [];
                    groupedOptions.push(facet.options.reduce(function (option, val) {
                        if (val.category !== '') {
                            option[val.category] = option[val.category] || [];
                            option[val.category].push(val);
                            return option;
                        } else {
                            option['noCategory'] = option['noCategory'] || [];
                            option['noCategory'].push(val);
                            return option;
                        }
                    }, Object.create(null))
                    );
                    return groupedOptions
                },
                toLowercase(string) {
                    return string.toLowerCase();
                },
                submitForm(e) {
                    e.preventDefault();
                    this.$refs.selects.forEach(select => {
                        if (select.value === '') select.setAttribute('disabled', '');
                    });
                    if (this.$refs.date.value === '') this.$refs.date.setAttribute('disabled', '');
                    if (this.$refs.text.value === '') this.$refs.text.setAttribute('disabled', '');
                    e.target.submit();
                }
            },
            mounted() {
                // Set data props according to data attributes in HTML template.
                if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
                if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
                if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
                if (this.$el.dataset.type) this.apiType = this.$el.dataset.type;
                if (this.$el.dataset.monthfilter) this.monthFilterName = this.$el.dataset.monthfilter;
                if (this.$el.dataset.ignorefacets) this.ignorefacets = this.$el.dataset.ignorefacets.split(',');
                this.fetchData();
            }
        });

        quickSearchApp.mount('#quickSearch');
    }
});